module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "logo l"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "44px",
      "margin-top": "10px",
      "margin-left": "10px"
    },
    attrs: {
      "src": "//official.cdn.qiyewan.com/logo_qiyewna.png",
      "alt": "企业湾logo",
      "title": "企业湾logo"
    }
  })]), _vm._v(" "), _c('div', {})], 1), _vm._v(" "), _c('ul', _vm._l((_vm.categories), function(item) {
    return _c('li', {
      class: {
        active: _vm.isActive(item.id)
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: item.href,
          query: {
            category: item.id
          }
        }
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-13d119a4!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/article/Header.vue
// module id = 1011
// module chunks = 40